import { CategoriesApiRemoteService } from '../../Services/api/categories/categories-service'
import { ICategoryEntity } from '../../Services/api/categories/categories.interface'
import { IFormUsecase } from '../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../Shared/Protocol/protocol-result'


export class ShowCategoriesUseCase
implements IFormUsecase<string, ICategoryEntity> {
  constructor (private readonly CategoriesApi: CategoriesApiRemoteService) {}
    

  public async handle (
    categoryId: string
  ): Promise<Result<ICategoryEntity>> {
    // eslint-disable-next-line no-useless-catch
    try {

      const response = await this.CategoriesApi.show(categoryId)

      if (response.isFailure) {
        return response
      }

    
      return Result.ok()
    } catch (error: any) {
      return Result.fail(error)
    }
  }

 
}
